var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileExcel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.526 5.919l-4.413-4.414a.655.655 0 00-.464-.192H3.938a.656.656 0 00-.657.656V19.03c0 .363.294.657.656.657h13.126a.656.656 0 00.656-.657V6.384a.66.66 0 00-.193-.465zm-1.32.767h-3.86v-3.86l3.86 3.86zm.036 11.525H4.758V2.789h6.193v4.43a.861.861 0 00.861.861h4.43v10.13zm-5.699-6.314l-1.267-2.1a.248.248 0 00-.212-.12h-.787a.23.23 0 00-.131.04.245.245 0 00-.076.34l1.688 2.674-1.71 2.724a.247.247 0 00.208.377h.708a.247.247 0 00.21-.117l1.285-2.081 1.278 2.08a.245.245 0 00.209.116h.769a.246.246 0 00.207-.38l-1.723-2.674 1.75-2.717a.246.246 0 00-.207-.38h-.733a.248.248 0 00-.21.12l-1.256 2.098z",
    fill: "#262626"
  })));
}

export default __webpack_public_path__ + "./fonts/fileExcel.524d6c7be83b75649fadcffdc47a1ed5.svg";
export { SvgFileExcel as ReactComponent };